<app-page-header title="Home" active_item="Transferir Saldo"></app-page-header>
<div class="loading-transfer-balance" *ngIf="!isLoaded">
  <div class="dimmer active">
    <div class="lds-ring">
      <div></div>
    </div>
  </div>
</div>
<h5>Transferência de Saldo</h5>
<div class="row">
  <div class="col-12">
    <div class="card sales-summary rounded-10 shadow">
      <div class="card-header">
        <div class="card-title mb-0">Dados da Transferência</div>
      </div>
      <div class="card-body">
        <div class="alert alert-dark text-center" role="alert">
          <b
            >Saldo Disponível: R$
            {{
              saldoDisponivel
                | mask : "separator.2" : { decimalMarker: ",", thousandSeparator: ".", leadZero: true }
            }}</b
          >
        </div>
        <form [formGroup]="transferBalance">
          <div class="row">
            <div class="col-xl-7 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtNomeFavorecido" class="form-label">Conta <span class="text-danger">*</span></label>
                <input class="form-control" [ngClass]="{'is-invalid state-invalid': transferBalance.controls.conta.invalid && isSubmitted}" [formControl]="transferBalance.controls.conta" type="text" name="nomeFavorecido" id="txtNomeFavorecido" [required]="true">
                <div class="invalid-feedback">{{contaFeedBack}}</div>
              </div>
            </div>
            <div class="col-xl-3 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtValorSolicitado" class="form-label"
                  >Valor <span class="text-danger">*</span></label
                >
                <input
                  [placeholder]="placeholderValue"
                  [formControl]="transferBalance.controls.valorSolicitado"
                  currencyMask
                  [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                  class="form-control"
                  type="text"
                  name="valorSolicitado"
                  id="txtValorSolicitado"
                  (focusout)="valorSolicitadoChanged()"
                  [ngClass]="{
                    'is-invalid state-invalid':
                    transferBalance.controls.valorSolicitado.invalid && isSubmitted
                  }"
                />
                <div class="invalid-feedback">{{ valorFeedBack }}</div>
              </div>
            </div>
            <div class="col-xl-1 col-lg-6 col-sm-6">
              <button
                type="button"
                class="our-button btn btn-pill btn-primary"
                (click)="openDataConfirm()"
              >
                <i class="fe fe-arrow-up-right"></i>Transferir
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<div class="row" *ngIf="openConfirm">
  <div class="col-12">
    <div class="card sales-summary rounded-10 shadow">
      <div class="card-header">
        <div class="card-title mb-0">Confirmar os dados</div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-xl-6 col-lg-12 col-sm-12">
            <div class="form-group">
              <label for="txtNomeProprietario" class="form-label"
                >Pagador</label
              >
              <input
                [(ngModel)]="nomePagador"
                class="form-control"
                type="text"
                name="valorSolicitado"
                id="txtNomeProprietario"
                [readonly]="true"

              />
            </div>
          </div>
          <div class="col-xl-4 col-lg-6 col-sm-6">
            <div class="form-group">
              <label for="txtDocumentoRecebedor" class="form-label"
                >Recebedor
              </label>
              <input
                [(ngModel)]="nomeRecebedor"
                class="form-control"
                type="text"
                name="valorSolicitado"
                id="txtDocumentoRecebedor"
                [readonly]="true"
              />
            </div>
          </div>
          <div class="col-xl-1 col-lg-6 col-sm-6">
            <button
              type="button"
              class="our-button btn btn-pill btn-primary"
              (click)="makeFundTransfer()"
            >
              <i class="fe fe-arrow-up-right"></i>Confirmar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #requestTOTPCode let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Informe o token de autenticação</h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click'); isLoaded = true"
    ></button>
  </div>
  <div class="modal-body">
    <div class="form-group mt-2">
      <p *ngIf="errorMessage.length > 0" class="text-danger">
        {{ errorMessage }}
      </p>
    </div>
    <div class="form-group mb-3">
      <input
        type="text"
        class="form-control"
        id="authToken"
        placeholder="Token"
        [(ngModel)]="validationCode"
        (keyup.enter)="validateTotp()"
      />
    </div>
  </div>
  <div class="modal-footer text-center">
    <button
      type="submit"
      class="btn btn-lg btn-primary btn-pill mx-auto d-block"
      (click)="validateTotp()"
    >
      VALIDAR
    </button>
  </div>
</ng-template>
